import pino from 'pino';

// Determine log level based on environment
const getLogLevel = () => {
    const env = process.env.REACT_APP_ENVIRONMENT;

    switch (env) {
        case 'local':
        case 'development':
            return 'debug';
        case 'staging':
            return 'warn';
        case 'production':
            return 'error';
        default:
            return 'info';
    }
};

// Create and configure logger for browser
const logger = pino({
    level: getLogLevel(),
    browser: {
        asObject: false,
        write: {
            /* eslint-disable no-console */
            debug: (o) => console.debug(o),
            error: (o) => console.error(o),
            fatal: (o) => console.error(o),
            info: (o) => console.info(o),
            trace: (o) => console.trace(o),
            warn: (o) => console.warn(o),
            /* eslint-enable no-console */
        },
    },
});

export default logger;
